import { useAuthStore } from '@/store/modules/auth';
import { defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
export default defineComponent({
    name: 'UserProfileHeader',
    setup() {
        const authStore = useAuthStore();
        const { user } = storeToRefs(authStore);
        return {
            user,
        };
    },
});
